import { Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { styles } from "../styles/activityStyles";
import { useTheme } from "@mui/material/styles";
import DblChevronRight from "../assets/dbl-chevron-right.svg";

// Clicking a tile opens the Incidents list filtered to what the tile counts.
const ActivityCard = ({ config, data, scope }) => {
  const theme = useTheme();
  const style = styles(theme);
  const navigate = useNavigate();
  const open = (item) => {
    if (!item.preset) return;
    navigate("/incidents", {
      state: { preset: item.preset, district: scope?.district || "", school: scope?.school || "" },
    });
  };

  return (
    <Container sx={style.activityContainer}>
      {config.map((item, index) => {
        return (
          <Container
            key={index}
            sx={{ ...style.activityCard, cursor: item.preset ? "pointer" : "default",
                  "&:hover": item.preset ? { boxShadow: 3 } : undefined }}
            role={item.preset ? "button" : undefined}
            tabIndex={item.preset ? 0 : undefined}
            aria-label={item.preset ? `Open ${item.name}` : undefined}
            onClick={() => open(item)}
            onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); open(item); } }}
          >
            <Container sx={style.row1}>
              <Typography sx={style.title}>
                {item.name}
              </Typography>
              <Typography sx={style.chevronRight}>
                <img src={DblChevronRight} alt="chevron-right" />
              </Typography>
            </Container>
            <Container sx={style.row2}>
              <Container sx={style.dataContainer}>
                <img src={item.icon} alt="icon"/>
                <Typography sx={style.data}>
                  {data[item.field]}
                </Typography>
              </Container>
              <Typography sx={style.activityCardMessage}>
                {item.message}
              </Typography>
            </Container>
          </Container>
        );
      })}
    </Container>
  );
};

export default ActivityCard;
